module.exports = __webpack_public_path__ + "static/modernizace-php-aplikaci-1-f3e70b760b7c455182769698f3dc944b.jpg";